/**
 * **Welches Projekt im Hauptfenster gerade offen ist** (localStorage, je Gerät, nicht synchronisiert).
 *
 * Geschrieben von `MainLayout`, sobald der vordere Tab wechselt; gelesen von der Schnelleingabe (#234):
 * Gibt es zwei Projekte „Test“, meint `#Test` das offene. Das Fenster der Schnelleingabe ist ein eigener
 * Renderer und teilt mit dem Hauptfenster nur diesen Speicher — wie beim aktiven Lebensbereich.
 */

const KEY = 'open-project'

export function rememberOpenProject(projectId: string | null): void {
  try {
    if (projectId) localStorage.setItem(KEY, projectId)
    else localStorage.removeItem(KEY)
  } catch { /* ignore (storage full / privacy mode) */ }
}

export function getOpenProjectId(): string | null {
  try {
    return localStorage.getItem(KEY)
  } catch {
    return null
  }
}
